// extracted by mini-css-extract-plugin
export default {"mediaItem":"Kua39N0IWQggLg0CbWCO","mediaItemMedia":"SYfEBP1Hzo4MhUkfjq_l","mediaItemContent":"xuueuJ_4jXgFq67wh8mY","mediaItemCaption":"JbN4c0PeVQ8CO2ksZYTA"};